export enum sizeOptions {
  sm = "sm",
  md = "md",
  lg = "lg",
}
